import { TextField, InputAdornment, IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close"; // New icon for clearing

const SearchBar = ({ sx, searchQuery, setSearchQuery }) => {
  const handleClear = () => setSearchQuery("");

  return (
    <TextField
      fullWidth
      variant="outlined"
      placeholder="Search brand or booth number"
      value={searchQuery}
      onChange={(e) => setSearchQuery(e.target.value)}
      sx={{
        ...sx,
        borderRadius: "20px",
        overflow: "hidden",
        "& .MuiOutlinedInput-root": {
          borderRadius: "20px",
          borderColor: "#ccc",
          "&:hover": { borderColor: "#aaa" },
          "&.Mui-focused": { borderColor: "#007bff" },
        },
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon sx={{ color: "gray" }} />
          </InputAdornment>
        ),
        endAdornment: searchQuery ? (
          <InputAdornment position="end">
            <IconButton onClick={handleClear}>
              <CloseIcon sx={{ color: "gray" }} />
            </IconButton>
          </InputAdornment>
        ) : null,
      }}
    />
  );
};

export default SearchBar;
